
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_y99km_3",
  "tools": "awsui_tools_wih1l_y99km_12",
  "tools-filtering": "awsui_tools-filtering_wih1l_y99km_18",
  "tools-align-right": "awsui_tools-align-right_wih1l_y99km_22",
  "tools-pagination": "awsui_tools-pagination_wih1l_y99km_26",
  "tools-preferences": "awsui_tools-preferences_wih1l_y99km_26",
  "tools-small": "awsui_tools-small_wih1l_y99km_32",
  "table": "awsui_table_wih1l_y99km_38",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_y99km_44",
  "wrapper": "awsui_wrapper_wih1l_y99km_48",
  "variant-stacked": "awsui_variant-stacked_wih1l_y99km_58",
  "variant-container": "awsui_variant-container_wih1l_y99km_58",
  "variant-embedded": "awsui_variant-embedded_wih1l_y99km_62",
  "has-header": "awsui_has-header_wih1l_y99km_65",
  "has-footer": "awsui_has-footer_wih1l_y99km_68",
  "cell": "awsui_cell_wih1l_y99km_72",
  "header-cell": "awsui_header-cell_wih1l_y99km_77",
  "header-cell-sticky": "awsui_header-cell-sticky_wih1l_y99km_87",
  "header-cell-stuck": "awsui_header-cell-stuck_wih1l_y99km_90",
  "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_wih1l_y99km_93",
  "header-cell-sortable": "awsui_header-cell-sortable_wih1l_y99km_99",
  "body-cell": "awsui_body-cell_wih1l_y99km_112",
  "body-cell-wrap": "awsui_body-cell-wrap_wih1l_y99km_120",
  "row": "awsui_row_wih1l_y99km_133",
  "row-selected": "awsui_row-selected_wih1l_y99km_139",
  "next-row-selected": "awsui_next-row-selected_wih1l_y99km_158",
  "cell-merged": "awsui_cell-merged_wih1l_y99km_187",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_y99km_191",
  "empty": "awsui_empty_wih1l_y99km_204",
  "loading": "awsui_loading_wih1l_y99km_208",
  "selection-control": "awsui_selection-control_wih1l_y99km_212",
  "sorting-icon": "awsui_sorting-icon_wih1l_y99km_224",
  "header-cell-disabled": "awsui_header-cell-disabled_wih1l_y99km_231",
  "header-cell-sorted": "awsui_header-cell-sorted_wih1l_y99km_231",
  "header-cell-content": "awsui_header-cell-content_wih1l_y99km_231",
  "header-cell-fake-focus": "awsui_header-cell-fake-focus_wih1l_y99km_264",
  "header-cell-ascending": "awsui_header-cell-ascending_wih1l_y99km_293",
  "header-cell-descending": "awsui_header-cell-descending_wih1l_y99km_294",
  "header-cell-text": "awsui_header-cell-text_wih1l_y99km_298",
  "header-cell-text-wrap": "awsui_header-cell-text-wrap_wih1l_y99km_298",
  "sticky-scrollbar": "awsui_sticky-scrollbar_wih1l_y99km_304",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_wih1l_y99km_314",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_wih1l_y99km_317",
  "header-secondary": "awsui_header-secondary_wih1l_y99km_321",
  "header-controls": "awsui_header-controls_wih1l_y99km_341",
  "thead-active": "awsui_thead-active_wih1l_y99km_358",
  "divider": "awsui_divider_wih1l_y99km_362",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_y99km_369",
  "footer": "awsui_footer_wih1l_y99km_369"
};
  